import React,{ useState } from 'react'
import Transparent from './images/transparent.gif'
import { Link} from "react-router-dom";
import Cookies from 'universal-cookie';

const cookies = new Cookies();


export default function Header(props) {
	const [loading, setloading] = useState(false);

	const handlerefresh = ()=>{
		setloading(true);
		props.checkUpdateBalance(); 
       setTimeout(()=>{setloading(false);},1000);
	}

	// console.log(props.balance,'dsfgh');
    return (
   <React.Fragment>
   <div class="top">
   <div class="header">
    <h1><Link to="/agents" style={{width:'180px',marginTop:'-13px',backgroundRepeat:' no-repeat',backgroundSize:' contain'}}>gamex</Link></h1>
    <ul class="account-wrap">
	 {/* <li><span>{props.level}</span><strong>{props.user}</strong></li> */}
	 <li><span>ADMIN</span><strong>{props.user}</strong></li>
	  {/* <!-- single balance 加 no-multi --> */}
      <li class="main-wallet no-multi">
      	{/* <!-- open--> */}
      	<a class="a-wallet">
			  {loading === false &&
      		<ul>
      			<li>
      				<span>Main</span>
      				<strong id="mainBalance">PBU {parseFloat(props.balance).toFixed(2)}</strong>
      			</li>
      		</ul>
			  }
			{loading === true &&
      		<p class="loading-bar" id="menuRefreshLoading">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</p>}
      	</a>

		<a id="topRefresh" class="a-refresh" onClick={()=>{handlerefresh()}} style={{cursor:'pointer'}}><img src={Transparent}/></a>
      </li>
    </ul>
  </div>

  {/* <!-- Menu Wrap --> */}
  <div class="menu-wrap">
    <div class="main_wrap">
      <ul class="menu">
		  {/* {	props.level === "ML" &&
		    <li><Link to="/">EventManagement
	      </Link></li>} */}

		  <li><Link to ="/agents" onClick={()=>{var url = window.location.href;var para = url.split( '/' );var eventT = para[3];if(eventT === 'agents')window.location.reload();}} id="menu_downline_list" className={`${(props.tabMenu===1 )? "select": "null"}`} >Downline List
	      </Link></li>
	      
	      <li>
		      <Link to="/agent/myAccount/accountSummary" id="menu_my_account" className={`${(props.tabMenu===2 || props.tabMenu===9 || props.tabMenu===10 || props.tabMenu===11 || props.tabMenu===12)? "select": "null"}`}>My Account
		      </Link>
		  </li>

	      <li>
			  <a id="menu_my_report"  className={`${(props.tabMenu===3 || props.tabMenu===4)? "menu-drop select": "menu-drop" }`}>My Report
	      </a>
		      <ul>
			      
			      <li><a class="dropcolor" href="/agent/myReport/downLineProfitLoss" >Profit/Loss Report by Downline
			         </a>
				  </li>
			      <li><a class="dropcolor" href="/agent/myReport/marketProfitLoss" >Profit/Loss Report by Market
			        </a>
				  </li>  
				  {/* <li><a class="dropcolor" href="/casinoProfitLoss" >Profit/Loss Report of Casino
			        </a>
				  </li>       */}
		      </ul>
	      </li>
	      <li><Link to="/agent/betList/betList" id="menu_bet_list" className={`${(props.tabMenu===5 || props.tabMenu===21)? "select": "null"}`} >Bet List
	      </Link></li>
	      <li><Link to="/agent/betList/betListLive" id="menu_bet_list_live" className={`${(props.tabMenu===6)? "select": "null"}`} >BetList Live
	      </Link></li>
	      <li><Link to="/agent/ManageBet/ManageBet" id="menu_risk_management" className={`${(props.tabMenu===7)? "select": "null"}`}>Risk Managment
	      </Link></li>
	     {props.level !== 'MA' && <li>
			 <Link to="/agentBanking" id="menu_banking" className={`${(props.tabMenu===8)? "select": "null"}`}>Banking
	      </Link></li>}
		  {props.level === 'MA' &&	  <li><Link to="/playerBanking" id="menu_banking" className={`${(props.tabMenu===15)? "select": "null"}`}>Banking
	      </Link></li>}
		  {	props.level === "ML" &&	
			  <li><Link to="/alert" id="menu_banking" className={`${(props.tabMenu===22)? "select": "null"}`}>Alert
	      </Link></li>}
		  {	props.level === "ML" &&
		  <li><a id="menu_banking" className={`${(props.tabMenu===22)? "select": "null"}`}>Notification
	      </a></li>}
		  {/* <li><Link to="/agent/myshare/myshare" id="Share_Comm" className={`${(props.tabMenu===25)? "select": "null"}`}>Share Commission
	      </Link></li> */}
		  {/* <li>
			  <Link to="/casinocontrol" id="menu_casinocontrol" target="_blank" className={`${(props.tabMenu===23)? "select": "null"}`}>Casino Control
	      </Link></li> */}
		 {/* <li><a id="menu_dashboard" class="">Dashboard
		  </a></li>*/}
        <li class="logout">
          <a onClick = {()=>{cookies.remove('sid',  { path: '/' });setTimeout(()=>{window.location.href = '/';},200);}} id="logout">Logout<img src={Transparent}/></a>
        </li>
        <li class="time_zone"><span>Time Zone :</span> GMT+5:30</li>
      </ul>
    </div>
  </div>
</div>
        </React.Fragment>
    )
}
